let IntentosPost4 = 0;
const PostFile = (urlC, body, nombre, resp) => {
    fetch(urlC, {
        method: 'POST',
        body: JSON.stringify(body),
        headers:{'Content-Type' : 'application/json', 'charset' : 'UTF-8'},})
    .then(response => response.blob())
    .then(blob => {
        if (blob.size < 10) {
            resp ("error");
        }else{
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = url;
            a.download = `${nombre}`;
            document.body.appendChild(a)
            a.click(); 
            a.remove();
            resp("ok")
        }
    },error => {
        IntentosPost4++;
        (IntentosPost4 > 5) ? IntentosPost4 = 0 : PostFile(urlC, body, nombre, (respuesta) => {
            resp(respuesta)
        })
        console.error('Ocurrió un error al cargar. Reintentando. ', error);
    })
    
}

export default PostFile;


// WEBPACK FOOTER //
// ./src/shared/PostFile.jsx